export default (event) => {
  window.ReactNativeWebView.postMessage(event)
}
